export default "__VITE_ASSET__Aud0WW$8__"